export default __webpack_public_path__ + "static/media/gallery_05.c4e5dfb8.jpg";